import { useState, useEffect } from 'react';

export default function LoadingScreen({ onComplete }) {
  const [phase, setPhase] = useState(0); // 0=logo, 1=text, 2=line, 3=exit

  useEffect(() => {
    const t1 = setTimeout(() => setPhase(1), 400);
    const t2 = setTimeout(() => setPhase(2), 1000);
    const t3 = setTimeout(() => setPhase(3), 2200);
    const t4 = setTimeout(() => onComplete(), 2800);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); };
  }, [onComplete]);

  return (
    <div className={`loading-screen${phase >= 3 ? ' exit' : ''}`}>
      <div className="loading-content">
        {/* Rotating ring */}
        <div className={`loading-ring${phase >= 0 ? ' visible' : ''}`}>
          <svg viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="46" className="loading-ring-track" />
            <circle cx="50" cy="50" r="46" className="loading-ring-progress" />
          </svg>
          <div className="loading-ring-dot" />
        </div>

        {/* Diamond */}
        <div className={`loading-diamond${phase >= 0 ? ' visible' : ''}`} />

        {/* Logo text */}
        <div className={`loading-title${phase >= 1 ? ' visible' : ''}`}>
          NİŞANTAŞI
        </div>
        <div className={`loading-subtitle${phase >= 1 ? ' visible' : ''}`}>
          Erkek Kuaför Salonu
        </div>

        {/* Line */}
        <div className={`loading-line${phase >= 2 ? ' visible' : ''}`} />

        {/* Tagline */}
        <div className={`loading-tagline${phase >= 2 ? ' visible' : ''}`}>
          Stilinizi yeniden tasarlıyoruz
        </div>
      </div>
    </div>
  );
}
